import Entity from './entity'
export default class Ththreshold extends Entity<number>{
    tName:string;
}